export default "<div class=\"container\">\n  <div class=\"my-5\" [innerHTML]=\"content\"></div>\n</div>\n"